import * as React from 'react'
import { useState, useEffect } from "react"
import { FORMAT_DATE_BACK, formatDate, postSubmit } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'
import { useCommonFilters } from "../../hooks"
import RadioElements from './RadioElements'
import { AppTooltip } from 'app/@components'


export default function RadioMultiButton(props) {

    const [sites, setSites] = useState(null)
    const { title='', items, value, onChange, market, date, customDates, refresh, disabled } = props
    const { otherSites, setElementsOtherSites } = useCommonFilters()

    useEffect(() => {
        if (!!date) {
            postSubmit(COMPETITION_URL.SITES, {
                market: market,
                dateRange: date,
                ...refresh && { refresh_cache: refresh },
                ...date === 'custom' && { 
                    startDate: formatDate(customDates[0], { format: FORMAT_DATE_BACK }),
                    endDate: formatDate(customDates[1], { format: FORMAT_DATE_BACK })
                }
            }).then(data => {
                setSites(data)
                onChange(data[0]?.value)

                setElementsOtherSites(data.filter(a => !a.button))
            })
        } else setSites(null)
            
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [market, date, refresh])

    const listItems = !!sites && items.map((a, i) => {
        if (sites[i]?.button === i+1) return {
            value: sites[i].value,
            label: sites[i].label
        }
        return {
            value: a.value,
            label: a.label
        }
    })

    if (!sites && !listItems) return <SelectLoading />

    return <div className={`switch-field ${!!otherSites && 'other-sites'}`}>
        <div className="switch-title">{title}</div>
        { !!sites && listItems.map((item, id) => {
            if (id === 2 && sites[id]?.name_official_site?.length) return <AppTooltip
                title={sites[id].name_official_site.map(a => { return <p key={a} style={{ margin: '0' }}>{a}</p> })}
                placement="bottom"
            >
                <button className={`btn btn-outline-primary ${value === id ? 'active' : ''}`} onClick={() => onChange(id)}>
                    {sites[id].name}
                </button>
            </AppTooltip>

            return <RadioElements item={item} key={id} id={id} onChange={onChange} value={value} sites={sites} disabled={disabled} />
        }) }
    </div>
}